import { Controller } from "stimulus";
import tippy from "tippy.js";

import 'select2';
import 'select2/dist/css/select2';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';
import { isEmpty } from "lodash";
import sweet_alert from "../entrypoints/src/admin/utilities/sweet_alert";

export default class extends Controller {
  static targets = [
    'markPaid',
    'containerPaid',
    'netValue',
    'originalValue',
    'discountValue',
    'selectPaymentMethod',
    'gatewayButton',
    'saveButton'
  ];

  onUpdatePaymentMethod() {
    !!this.hasGatewayButtonTarget && $(this.gatewayButtonTarget).css(
      'display',
      this.markPaidTarget.checked ||
        this.selectPaymentMethodTarget.selectedOptions[0].dataset.chargeable !== 'true'
        ? 'none'
        : 'inline-block'
    );

    !!this.hasContainerPaidTarget && this.containerPaidTarget.classList.toggle('hidden', !this.markPaidTarget.checked);
    let chargeablePaymentMethodContainer = document.querySelector('.info-chargeable-payment-method');

    if (!chargeablePaymentMethodContainer || !this.hasMarkPaidTarget)
      return;

    chargeablePaymentMethodContainer.classList.toggle('hidden', this.markPaidTarget.checked || this.selectPaymentMethodTarget.selectedOptions[0].dataset.chargeable !== 'true');
  }

  connect() {
    this.hasSelectPaymentMethodTarget && $(this.selectPaymentMethodTarget).on('select2:select', this.onUpdatePaymentMethod.bind(this));
    this.hasMarkPaidTarget && this.markPaidTarget.addEventListener('change', () => this.onUpdatePaymentMethod());

    this.hasDiscountValueTarget && this.discountValueTarget.addEventListener('change', () => {
      this.netValueTarget.value = this.subtractNumbers(isEmpty(this.originalValueTarget.value) ? this.discountValueTarget.dataset.netValueCents : this.originalValueTarget.value, this.discountValueTarget.value);
    });

    this.hasNetValueTarget && this.netValueTarget.addEventListener('change', () => {
      if (!isEmpty(this.originalValueTarget.value)) {
        this.discountValueTarget.value = this.subtractNumbers(this.originalValueTarget.value, this.netValueTarget.value);
      } else if (!isEmpty(this.discountValueTarget.value)) {
        this.originalValueTarget.value = this.sumNumbers(this.discountValueTarget.value, this.netValueTarget.value);
      }
    });

    this.hasOriginalValueTarget && this.originalValueTarget.addEventListener('change', () => {
      if (!isEmpty(this.discountValueTarget.value)) {
        this.netValueTarget.value = this.subtractNumbers(this.originalValueTarget.value, this.discountValueTarget.value);
      } else if (!isEmpty(this.netValueTarget.value)) {
        this.discountValueTarget.value = this.subtractNumbers(this.originalValueTarget.value, this.netValueTarget.value);
      }
    });

    tippy('[data-tippy-content]', {
      allowHTML: true,
      animation: 'scale',
      interactive: true,
      duration: [100, 0],
      delay: [500, 0],
      theme: 'traus-light',
      appendTo: document.body
    });

    $(this.element.querySelectorAll('.select2')).select2({
      dropdownParent: this.element.closest('.modal'),
      escapeMarkup: (markup) => markup,
    });

    $('.select2.disabled').prop("disabled", true);

    this.onUpdatePaymentMethod()
  }

  handleGatewayButtonClick(event) {
    event.preventDefault();

    this.confirmPaymentThroughGateway().then((result) => {
      if (result.isConfirmed) {
        this.setGatewayPaymentValue();

        // Simula o clique no botão "Salvar"
        this.saveButtonTarget.click();
      }
    });
  }

  confirmPaymentThroughGateway() {
    return sweet_alert.fire({
      title: 'Confirmar cobrança',
      text: "Deseja realmente cobrar através do gateway configurado?",
      showCancelButton: true,
      confirmButtonText: 'Sim, cobrar!',
      cancelButtonText: 'Cancelar'
    });
  }

  setGatewayPaymentValue() {
    const payThroughGwField = this.element.querySelector('input[name*="[pay_through_gw]"]');
    if (payThroughGwField) {
      payThroughGwField.value = '1';
    }
  }

  subtractNumbers(a, b) {
    a = +a.replaceAll(/[^\d]/gi, '');
    b = +b.replaceAll(/[^\d]/gi, '');
    let result = 0;

    if ((a - b) > 0)
      result = ((a - b) / 100);

    return result.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  sumNumbers(a, b) {
    a = +a.replaceAll(/[^\d]/gi, '');
    b = +b.replaceAll(/[^\d]/gi, '');

    return ((a + b) / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
}